export default "__VITE_ASSET__K3ZDLg7P__"